import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-user-bg",
  "use": "foquz-icon-user-bg-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" id=\"foquz-icon-user-bg\"><path fill=\"#CFD8DC\" d=\"M-8-8h49v52H-8z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 17a5 5 0 100-10 5 5 0 000 10zm0-2a3 3 0 100-6 3 3 0 000 6zm0 27c6.627 0 12-5.373 12-12s-5.373-12-12-12S3 23.373 3 30s5.373 12 12 12zm0-2c5.523 0 10-4.477 10-10s-4.477-10-10-10S5 24.477 5 30s4.477 10 10 10z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol